/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1CouponIdEnrollmentLinks202,
  PostApiV1CouponIdEnrollmentLinks400,
  PostApiV1CouponIdEnrollmentLinks401,
  PostApiV1CouponIdEnrollmentLinks404,
  PostApiV1CouponIdEnrollmentLinks500,
  PostApiV1CouponIdEnrollmentLinksMutationRequest,
  PostApiV1CouponIdEnrollmentLinksMutationResponse,
  PostApiV1CouponIdEnrollmentLinksPathParams,
} from "../../types/couponLinksDeMatrculaController/PostApiV1CouponIdEnrollmentLinks.ts";
import { couponEnrollmentLinksViewModelSchema } from "../couponEnrollmentLinksViewModelSchema.ts";
import { saveCouponEnrollmentLinksRequestViewModelSchema } from "../saveCouponEnrollmentLinksRequestViewModelSchema.ts";

export const postApiV1CouponIdEnrollmentLinksPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1CouponIdEnrollmentLinksPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1CouponIdEnrollmentLinks202Schema = z.lazy(
  () => couponEnrollmentLinksViewModelSchema,
) as unknown as ToZod<PostApiV1CouponIdEnrollmentLinks202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1CouponIdEnrollmentLinks400Schema =
  z.any() as unknown as ToZod<PostApiV1CouponIdEnrollmentLinks400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1CouponIdEnrollmentLinks401Schema =
  z.any() as unknown as ToZod<PostApiV1CouponIdEnrollmentLinks401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1CouponIdEnrollmentLinks404Schema =
  z.any() as unknown as ToZod<PostApiV1CouponIdEnrollmentLinks404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1CouponIdEnrollmentLinks500Schema =
  z.any() as unknown as ToZod<PostApiV1CouponIdEnrollmentLinks500>;

export const postApiV1CouponIdEnrollmentLinksMutationRequestSchema = z.lazy(
  () => saveCouponEnrollmentLinksRequestViewModelSchema,
) as unknown as ToZod<PostApiV1CouponIdEnrollmentLinksMutationRequest>;

export const postApiV1CouponIdEnrollmentLinksMutationResponseSchema = z.lazy(
  () => postApiV1CouponIdEnrollmentLinks202Schema,
) as unknown as ToZod<PostApiV1CouponIdEnrollmentLinksMutationResponse>;
